import React from "react";
import { Container, Row, Col, Card, Accordion } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import ContentHeading from "../components/ContentHeading";
import "../assets/styles/privacypolicy.css"

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | ASK & Associates</title>
        <meta
          name="description"
          content="Detailed privacy policy of ASK & Associates explaining data collection, usage, storage, cookies, security, and user rights."
        />
        <link
          rel="canonical"
          href="https://askandassociates.com/privacy-policy"
        />
      </Helmet>

      <section className="section bg-lotion">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11}>
              <Card className="border-0 shadow-sm rounded-4 p-4 p-md-5">
                {/* Header */}
                <div className="mb-4">
                  <ContentHeading heading="Legal Information" />
                  <h1 className="display-6 fw-600 text-eerie-black mb-3">
                    Privacy Policy
                  </h1>
                  <p className="text-dark-charcoal">
                    This Privacy Policy explains how ASK & Associates ("we",
                    "our", "us") collects, uses, stores, processes, and protects
                    personal information when users visit our website or engage
                    with our architecture, interior design, and project
                    management consultancy services.
                  </p>
                </div>

                {/* ACCORDION (single open only) */}
                <Accordion
                  defaultActiveKey="0"
                  flush
                  className="custom-accordion"
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      1. Information We Collect
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        We collect personal information such as name, email,
                        phone number, project details, location, drawings, and
                        any other information you voluntarily provide through
                        contact forms, emails, calls, or WhatsApp.
                      </p>
                      <p>
                        We may also collect technical data like IP address,
                        browser type, device information, and pages visited to
                        improve website performance.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      2. How We Use Your Information
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        Your information is used to respond to inquiries,
                        prepare proposals, deliver architectural and consultancy
                        services, improve user experience, and comply with legal
                        requirements.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      3. Cookies & Tracking Technologies
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        We use cookies and analytics tools to analyze traffic
                        and improve website functionality. Cookies can be
                        disabled via browser settings.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      4. Data Security
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        We use appropriate technical and organizational
                        safeguards to protect personal information. However, no
                        online system is completely secure.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      5. Sharing of Information
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        We do not sell personal data. Information may be shared
                        only with trusted partners for service delivery, under
                        strict confidentiality obligations.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      6. User Rights
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        You may request access, correction, or deletion of your
                        personal data by contacting us using the details below.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      7. Contact Information
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>
                        <strong>Email:</strong> askandassociates2017@gmail.com
                        <br />
                        <strong>Phone:</strong> +91-7021222937
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PrivacyPolicy;
